import PropTypes from "prop-types";
import DOMPurify from "dompurify";
import Text from "../../component/text/Text";
import {
  formatDeliverySummary,
  getAudienceSummaryDisplay,
  stripHtmlToPlainText,
} from "./campaignFormHelpers.js";

export default function CampaignFormSummary({
  input,
  institutionTz,
  scheduleOptions,
  tripTypes,
  familyLabels,
  stopLabels,
  scheduleLabels,
  formSteps = [],
  currentStep = 0,
}) {
  const plainMessage = stripHtmlToPlainText(input.message);
  const previewHtml = input.message
    ? DOMPurify.sanitize(input.message)
    : "";

  const activeStep = formSteps[currentStep];
  const audienceSummary = getAudienceSummaryDisplay(input, {
    scheduleOptions,
    tripTypes,
    familyLabels,
    stopLabels,
    scheduleLabels,
  });

  return (
    <aside className="campaign-form-summary" aria-label="Campaign summary">
      <div className="campaign-form-summary__card">
        <div className="campaign-form-summary__header">
          <Text
            text="Summary"
            size="0.875rem"
            color="#344054"
            weight="600"
          />
          {activeStep ? (
            <p className="campaign-form-summary__step">
              Step {currentStep + 1} of {formSteps.length} ·{" "}
              {activeStep.title}
            </p>
          ) : null}
        </div>
        <div className="campaign-form-summary__body">
          <dl className="campaign-form-summary__list">
            <div className="campaign-form-summary__row">
              <dt>Delivery</dt>
              <dd>{formatDeliverySummary(input, institutionTz)}</dd>
            </div>
            <div className="campaign-form-summary__row">
              <dt>Audience</dt>
              <dd>{audienceSummary}</dd>
            </div>
          </dl>
          {plainMessage ? (
            <div className="campaign-form-summary__preview">
              <Text
                text="Message preview"
                size="0.75rem"
                color="#667085"
                weight="500"
              />
              <div
                className="campaign-form-summary__preview-body"
                dangerouslySetInnerHTML={{ __html: previewHtml }}
              />
              {plainMessage.length > 160 ? (
                <p className="campaign-form-summary__preview-hint">
                  Plain text is {plainMessage.length} characters — some devices may
                  truncate long notifications.
                </p>
              ) : null}
            </div>
          ) : (
            <p className="campaign-form-summary__empty">
              Your message will appear here as you type.
            </p>
          )}
        </div>
      </div>
    </aside>
  );
}

CampaignFormSummary.propTypes = {
  input: PropTypes.object.isRequired,
  institutionTz: PropTypes.string,
  scheduleOptions: PropTypes.array,
  tripTypes: PropTypes.array,
  familyLabels: PropTypes.object,
  stopLabels: PropTypes.object,
  scheduleLabels: PropTypes.object,
  formSteps: PropTypes.array,
  currentStep: PropTypes.number,
};
